<!-- Model Header -->
<div class="d-flex model-container justify-content-between bg-color overflow-hidden">
    <h3 class="text-color f-w-600 p-l-10 m-y-auto">{{panel === 'edit' ? 'Edit' : 'Add'}} Property</h3>
    <button mat-icon-button class="text-color" (click)="this.dialogRef.close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Model Body -->
<div mat-dialog-content style="width: 100%; padding: 20px;" class="model-body">
    <form [formGroup]="propertyForm">


        <div>
            <div class="">
                <div class="p-10">
                    <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Property Detail</mat-label>
                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Property Name</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="email" readonly />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Property Address</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="email" readonly />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Builder Name</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Property Type</mat-label>
                            <mat-form-field class="theme-select" appearance="outline" style="width: 100%;">
                                <mat-select  value="mar">
                                    @for(option of options; track option ) {
                                    <mat-option [value]="option">
                                        {{ option }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <!-- <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Budget</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field> -->
                        </div>

                        <div class="col-12 col-md-6 col-lg-6 m-t-10">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Property Value</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    </form>
</div>

<!-- Model Footer -->
<div mat-dialog-actions>
    <button class="bg-color text-color" mat-button>Save</button>

    <button class="bg-color text-color" mat-button (click)="this.dialogRef.close()">Close</button>
</div>